import React from 'react';
import { googleSignIn } from 'config/firebase';
import Google from 'assets/images/Google.webp';
import './index.css';

function SignInWithGoogle({ className }: { className?: string; }) {
    return (
        <button 
            className={`signInWithGoogle ${className}`}
            type='button'
            onClick={googleSignIn}
        >
            <img 
                src={Google} 
                alt='Google' 
                className='signInWithGoogle__icon' 
            />
            Sign in with Google
        </button>
    );
}

export default SignInWithGoogle;